import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { RecordsCategoryFilterDataDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const createCategoryAsyncFilter = (
  apolloClient: ApolloClient<unknown>,
  companyId: string
): FilterDefinition => ({
  label: i18n.t('budgets.detail.tabs.spendings.table.filters.category'),
  type: 'in',
  options: {
    cache: true,
    options: async () => {
      const result = await apolloClient.query({
        query: RecordsCategoryFilterDataDocument,
        variables: { companyIds: [companyId] },
        fetchPolicy: 'cache-first'
      })

      const categories = result.data?.finance?.categories?.nodes || []
      return categories.map((cat) => ({
        label: cat.label,
        value: cat.identifier
      }))
    }
  }
})
